import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
import { BUY_URL, PRODUCT_IMAGE } from '../data/content';
const BADGES = [{
  emoji: '📄',
  label: '100% PDF'
}, {
  emoji: '⚡️',
  label: 'Entrega Inmediata'
}, {
  emoji: '📚',
  label: '7 Módulos + 5 Bonos'
}];
export function Hero() {
  return <section className="relative px-5 pt-10 pb-8" data-id="element-82">
      <div className="mx-auto max-w-md" data-id="element-83">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center font-anton text-3xl leading-[1.05] text-white sm:text-4xl" data-id="element-84">
          El sistema que te cubre{' '}
          <span className="text-[#F5C518]" data-id="element-85">las espaldas</span> a ti y a tus
          alumnos.
        </motion.h1>

        <motion.a href={BUY_URL} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mx-auto mt-6 block w-4/5 overflow-hidden rounded-2xl border border-white/10 bg-black/40 shadow-2xl" data-id="element-86">
          <img src={PRODUCT_IMAGE} alt="HYROX Definitivo 360 — Edición Coach: guía completa para entrenadores de HYROX" className="w-full" data-id="element-87" />
        </motion.a>

        <motion.p initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mx-auto mt-5 max-w-sm text-center text-sm leading-snug text-neutral-300 sm:text-base" data-id="element-88">
          El sistema completo para programar tus clases de HYROX, prevenir
          lesiones en tus alumnos y hacer crecer tu negocio, sin tener que
          improvisar cada semana.
        </motion.p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5" data-id="element-89">
          {BADGES.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-[#F5C518]/40 bg-[#F5C518]/10 px-3 py-1.5 text-sm font-600 text-white" data-id="element-90">
              <span aria-hidden="true" data-id="element-91">{b.emoji}</span>
              {b.label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-92">
          <BuyButton data-id="element-93" />
        </div>
      </div>
    </section>;
}